// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__jzJc4"};